/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

// Styles
import { main as mainStyle } from '../../../../../../style/main';

// SVGs
import checkmark from '../checkmark.svg';

// Helpers
import { deepObjectExtend } from '../../../../../../utils/object';

// eslint-disable-next-line import/prefer-default-export
export const RecipientBookStyle = (typography, palette) => deepObjectExtend(mainStyle(typography, palette), {
    heading: {
        paddingBottom: '20px',
        marginTop: '20px',
        borderBottom: '1.5px solid #e0e0e0',
        marginBottom: '20px',
    },
    listHeading: {
        fontWeight: '700',
        '& p': {
            fontSize: '16px !important',
        },
    },
    lastRelationshipSelf: {
        marginBottom: '24px',
        borderBottom: '1px solid #C4C4C4',
    },
    addNewRecipientWrapper: {
        width: '100%',
        '& .formStyle': {
            width: '100%',
            '& .mbp-account-MuiFormHelperText-root.Mui-error': {
                fontSize: '12px',
            },
            '& .mbp-account-MuiFormHelperText-root': {
                marginTop: '0px',
            },
            '& .mbp-account-MuiFilledInput-root': {
                background: '#F5F5F5',
                border: '1px solid #CFCFCF',
                borderRadius: '1px',
                opacity: '1',
            },
            '& .mbp-account-MuiFilledInput-underline:before, .mbp-account-MuiFilledInput-underline.Mui-error:after, .mbp-account-MuiFilledInput-underline:after, .mbp-account-MuiFilledInput-underline.Mui-focused:after': {
                borderBottom: 'none',
            },
            '& .mbp-account-MuiFilledInput-underline.Mui-error': {
                border: '1px solid red',
            },
            '& .mbp-account-MuiFormLabel-asterisk': {
                color: '#000000',
            },
            '& .mbp-account-MuiFormLabel-root': {
                color: '#000000',
            },
            '& .mbp-account-MuiFormHelperText-contained': {
                marginLeft: '0px',
                fontSize: '12px',
                color: 'red',
                marginBottom: '0px',
            },
            '& .mbp-account-MuiSelect-iconFilled': {
                color: '#000000!important',
            }
        },
        '& .newAddress': {
            fontWeight: 700,
            fontSize: '20px !important',
            marginBottom: '16px',
            '@media screen and (max-width: 768px)': {
                fontSize: '16px !important',
            },
        },
    },
    iconStyle: {
        fill: `${palette.iconColor} !important`,
    },
    iconStyleStroke: {
        stroke: `${palette.iconColor} !important`,
    },
    deleteIconStroke:{
        stroke: `${palette.colorPrimaryAccountCtaButton} !important`,
    },
    deleteIcon:{
        fill: `${palette.colorPrimaryAccountCtaButton} !important`,
    },
    occasionName: {
        color: '#000',
        fontFamily: 'Lato',
        fontSize: '16px !important',
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: '32px', /* 160% */
        letterSpacing: '0.2px',
        textTransform: 'capitalize !important',
        '@media screen and (max-width: 768px)': {
            lineHeight: '24px',
            fontSize: '16px !important',
        }
    },
    outlinedPrimaryBtn: {
        color: `${palette.colorPrimaryAccountCtaButton} !important`,
        border: `1px solid ${palette.colorPrimaryAccountCtaButton} !important`,
        borderRadius: '3px !important',
        backgroundColor: '#FFFFFF !important',
        padding: '11px 24px !important',
        fontFamily: 'Lato !important',
        fontSize: '16px !important',
        fontStyle: 'normal !important',
        fontWeight: '700 !important',
        lineHeight: '24px !important', /* 150% */
        letterSpacing: '0.64px',
        textTransform: 'capitalize !important',
    },
    container: {
        fontFamily: 'Lato',
        width: '100%',
    },
    title: {
        color: '#000000',
        fontSize: '24px !important',
        fontWeight: '700 !important',
        textAlign: 'center',
    },
    mediumTitle: {
        fontSize: '16px !important',
        fontWeight: '700 !important',
        marginBottom: '24px !important',
        '@media screen and (max-width: 768px)': {
            marginTop: '10px !important',
            fontSize: '16px !important',
            marginBottom: '16px !important',
        },
        // marginTop: '12px !important',
        color: '#000000 !important',
        textTransform: 'none !important',
        lineHeight: '32px !important',
    },
    searchField: {
        marginBottom: '1.5rem',
        position: 'relative',
        '& .mbp-account-MuiInputBase-input': {
            padding: '15px 15px',
            fontSize: '18px',
            backgroundColor: '#FAFAFA',
            fontWeight: '400',
            color: '#555555',
        },
        '& img': {
            position: 'absolute',
            right: '18px',
            top: '13px',
        },

    },
    noMargin: {
        margin: '0px'
    },
    addNewContactBtn: {
        textTransform: 'capitalize',
        fontWeight: '700',
        marginBottom: '1.5rem',
        borderRadius: '3px',
        padding: '10px',
        boxShadow: 'none',
        color: '#FFF'
    },
    filterAndSortContainer: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '1.5rem',
        justifyContent: 'space-between'
    },
    totalContacts: {
        textAlign: 'right',
        color: palette.common.black,
        fontSize: '16px !important',
    },
    commonBtn: {
        textDecoration: 'underline !important',
        color: `${palette.colorPrimaryAccountCtaButton} !important`,
        backgroundColor: `${palette.common.white} !important`,
        border: 'none !important',
        fontSize: '16px !important',
        minWidth: 'auto !important',
        paddingLeft: '0px !important',
        fontWeight: '400 !important',
        cursor: 'pointer',
    },
    editBtn: {
        color: `${palette.colorPrimaryAccountCtaButton} !important`,
        fontSize: '16px !important',
        fontWeight: '700 !important',
        textTransform: 'capitalize !important',
        backgroundColor: `${palette.common.white} !important`,
        border: 'none !important',
        borderBottom: `2px solid ${palette.colorPrimaryAccountCtaButton} !important`,
        padding: '0 0 2px 0px !important',
        minWidth: '0px !important',
        borderRadius: '0px !important',
    },
    commonBtnContained: {
        fontSize: '16px',
        background: `${palette.colorPrimaryAccountCtaButton} !important`,
        color: palette.common?.white,
        border: `1px solid ${palette.colorPrimaryAccountCtaButton} !important`,
        borderRadius: '3px !important',
        textTransform: 'capitalize !important',
        fontWeight: '700',
        '&:hover': {
            backgroundColor: `${palette.colorPrimaryAccountCtaButtonOnHover} !important`,
            color: `${palette.common.white}`,
            border: `1px solid ${palette.colorPrimaryAccountCtaButtonOnHover} !important`,
        },
        '&[disabled]': {
            border: `1px solid ${palette.disableButton} !important`,
            backgroundColor: `${palette.disableButton} !important`,
            color: 'rgba(0, 0, 0, 0.26) !important',
        },
    },
    divider: {
        marginTop: '20px !important',
        marginBottom: '20px !important',
    },
    shareBtn: {
        textDecoration: 'underline',
        color: palette.primary.main,
        backgroundColor: palette.common.white,
        border: 'none',
        fontSize: '16px !important',
    },
    reminderBtn: {
        color: `#000000 !important`,
        textDecoration: 'underline !important',
        border: 'none !important',
        fontSize: '16px !important',
        background: 'transparent !important',
        textDecorationLine: 'none !important',
        padding: '0px !important',
        margin: '0px !important',
        fontWeight: '500 !important',
    },
    yearFormField: {
        '& label': {
            fontSize: '16px !important', 
        },
        '& p': {
            margin: 0
        },
        '& span': {
            fontSize: '10px',
            '@media screen and (max-width: 420px)': {
                display: 'flex',
                flexWrap: 'wrap',
            },
        }
    },
    occasion: {
        display: 'flex',
        alignItems: 'center',
        '& svg': {
            marginRight: '10px',
        },
        '& span': {
            // marginTop: '4px',
            fontWeight: '700',
            fontSize: '16px !important',
        },
        '& p': {
            margin: 0,
        },
    },
    additionalOccasionsBtn: {
        '& .mbp-account-MuiToggleButtonGroup-root': {
            display: 'flex', 
            flexDirection: 'row', 
            justifyContent: 'center', 
            flexWrap: 'wrap',
            '& .mbp-account-MuiToggleButtonGroup-grouped:not(:last-of-type)': {
                borderRadius: '50px !important',
            },
            '& .mbp-account-MuiToggleButtonGroup-grouped:not(:first-of-type)': {
                borderRadius: '50px!important',
            },
            '& .Mui-selected, &.mbp-account-Mui-selected:active, .mbp-account-MuiToggleButton-root.Mui-selected': {
                backgroundColor: palette.primary.main,
                color: palette.common.white,
            },
        },
        '& .mbp-account-MuiToggleButton-root, .MuiToggleButton-root:hover': {
            margin: '0 13px 12px 0 !important',
            padding: '16px !important',
            textTransform: 'capitalize !important',
            fontSize: '16px !important',
            fontWeight: '400 !important',
            fontFamily: typography.fontFamily,
            backgroundColor: '#F5F5F5 !important',
            borderColor: '#F5F5F5 !important',
            display: 'inline-block !important',
            color: '#000000 !important',
            borderRadius: '30px !important',
            letterSpacing: '0.01em !important',
            minWidth: '125px',
            width: 'max-content !important',
        },
        '& .Mui-selected, .MuiToggleButton-root.Mui-selected, .mbp-account-MuiToggleButton-root.Mui-selected:focus, .MuiToggleButton-root.Mui-selected:focus': {
            backgroundColor: 'black !important',
            color: 'white !important'
        }
    },
    sectionTitle: {
        fontSize: '22px !important',
        fontWeight: 'bold',
    },
    sectionInfo: {
        color: '#7E7E7E',
        fontSize: '16px',
        fontWeight: 400,
    },
    addMailingAddress: {
        '& .headerContainer': {
            display: 'flex',
            alignItems: 'center',
            textWrap: 'nowrap',
            '& h3': {
                margin: '0px 25px 0px 0px',
                fontSize: '22px !important',
                lineHeight: '24px',
            },
        },
        '& .addressDetails': {
            fontFamily: 'Lato',
            fontSize: '16px !important',
            lineHeight: '24px',
            overflowWrap: 'break-word',
        },
        '& .addressNickname': {
            fontWeight: 700,
            fontSize: '20px !important',
            marginBottom: '8px',
            '@media screen and (max-width: 768px)': {
                fontSize: '16px !important',
            },
            '& span': {
                color: '#555555',
                fontSize: '20px !important',
                fontWeight: 400,
                '@media screen and (max-width: 768px)': {
                    fontSize: '16px !important',
                },
            },
        },
        '& .addMailingFormContainer': {
            marginTop: '8px',
            '& h4': {
                marginBottom: '5px',
            },
            '& p': {
                margin: '0px',
            },
            '& .addressList': {
                marginBottom: '20px',
                '& p': {
                    margin: 0,
                },
                '& .addressIndex': {
                    fontSize: '16px !important',
                    fontWeight: 700,
                },
            },
        },
        '& .addAddressBtn': {
            textTransform: 'none',
        },
    },
    dottedDivider: {
        border: 'none',
        borderTop: '2px dotted #000',
        color: '#fff',
        backgroundColor: '#fff',
        height: '1px',
        width: '100%',
        margin: 0,
    },
    showLess: {
        '& .MuiToggleButtonGroup-root': {
            maxHeight: '94px',
            overflow: 'hidden',
        },
    },
    expandMoreSection: {
        position: 'relative',
        height: '48px',
        maxWidth: '100vw',
        background: '#FFF',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& img': {
            position: 'absolute',
            width: '19px',
            zIndex: 2,
        },
    },
    expandMoreSectionOverlay: {
        position: 'absolute',
        top: '-40px',
        left: 0,
        zIndex: '2',
        width: '100%',
        height: '100%',
        background: 'linear-gradient(180.04deg, rgba(255, 255, 255, 0.15) 5.94%, #FFFFFF 37.11%)',
    },
    // check box custom styling start
    facetsCheckbox: {
        padding: '0px 13px 16px 0px',
        verticalAlign: 'top',
        '&.MuiCheckbox-colorPrimary.Mui-checked': {
            width: 26,
            height: 26,
            color: '#F5F5F5',
        },
    },
    customCheckbox: {
        width: '26px',
        height: '26px',
        border: '1px solid #C4C4C4',
        background: '#F5F5F5',
        borderRadius: '3px',
    },
    customCheckedCheckbox: {
        width: '26px',
        height: '26px',
        border: '1px solid #C4C4C4',
        background: '#F5F5F5',
        backgroundImage: `url("${checkmark}")`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        borderRadius: '3px',
    },
    reminderContainer: {
        'border': '1px solid',
        'marginTop': '20px',
        'paddingLeft': '20px',
    },
    subscribeContainer: {
        display: 'flex',
        flexDirection: 'column',
        maxWidth: '33.33%',
        '@media screen and (max-width: 768px)': {
            maxWidth: '100%',
            paddingRight: '20px',
        },
    },
    // check box custom styling end
    showPreferences: {
        transition: 'opacity 0.5s ease-in-out, max-height 0.5s ease-in-out',
        opacity: 1,
        maxHeight: '518px',
    },
    hidePreferences: {
        opacity: 0,
        maxHeight: 0,
        overflow: 'hidden',
        transition: 'opacity 0.5s ease-in, max-height 0.5s ease-in-out',
    },
    rotateIcon: {
        transform: 'rotate(180deg)',
    },
    errorStyling: {
        '& p': {
            marginLeft: '0px',
            fontSize: '12px',
            color: 'red',
            marginBottom: '16px !important',
        },
    },
    deleteBtn: {
        height: '26px !important', 
        fontFamily: 'Lato !important', 
        fontWeight: '700', 
        color: '#DF3030 !important',
        border: 'none !important',
        backgroundColor: 'transparent !important', 
        borderBottomWidth: '2px', 
        borderBottomStyle: 'solid !important', 
        textTransform: 'capitalize !important', 
        borderRadius: '0px !important', 
        width: 'max-content !important', 
        padding: '0px !important', 
        minWidth: '0px !important',
        float: 'none !important',
        '& .mbp-account-MuiButton-label': {
            fontSize: '16px !important',
        },
    },
    secondaryDeleteBtn: {
        borderBottomWidth: '1px !important',
        fontWeight: '400 !important',
    },
    deleteBtnIcon: {
        height: '26px !important', 
        border: 'none !important',
        padding: '0px !important', 
        minWidth: '0px !important',
        backgroundColor: 'transparent !important',
        marginRight: '0px !important',
    },
    addAddresses: {
        fontFamily: 'Lato !important',
        fontSize: '16px !important',
        fontWeight: '700 !important',
        height: '36px !important', 
        textTransform: 'capitalize !important',
        marginTop: '8px !important',
        borderRadius: '3px !important',
    },
    deleteThisAddress: {
        fontFamily: 'Lato !important',
        fontSize: '16px !important',
        fontWeight: '700 !important',
        height: '36px !important', 
        textTransform: 'capitalize !important',
        textDecoration: 'underline !important',
        borderRadius: '0px !important',
        marginBottom: '12px !important',
        borderColor: `${palette.colorPrimaryAccountCtaButton} !important`,
        color: `${palette.colorPrimaryAccountCtaButton} !important`,
    },
    primaryBtn: {
        background: palette.colorPrimaryAccountCtaButton,
        color: '#FFFFFF'
    },
    closeIcon: {
        cursor: 'pointer',
    },
    containerRecipient: {
        width: '74.8%',
        margin: '24px 3% 0px 5%',
    },
    desktopAddNewRecipient: {
        padding: '20px 24px 0px 20px',
        width: '100%',
    },
    backButtonContainer: {
        width: 'max-content',
        cursor: 'pointer',
    },
    backButtonIcon: {
        marginLeft: '8px',
        width: 'fit-content',
        fontWeight: 700,
    },
    formStyle: {
        width: '100%',
    },
    pageTitleWrapper: {
        margin: '3vh 0',
        paddingBottom: '15px',
        borderBottom: '1.5px solid #e0e0e0',
    },
    dividerStyle: {
        margin: '20px 0px',
        width: '100%',
    },
    marginTop24: {
        marginTop: '24px',
    },
    errorMessageContainer: {
        color: 'red',
        marginTop: '10px',
    },
    marginTop32: {
        marginTop: '32px',
    },
    gridItem: {
        borderRadius: '0px',
        marginTop: '8px'
    },
    buttonStyle: {
        margin: '24px 0px 80px 0px',
        textAlign: 'center'
    },
    noRecipient: {
        textAlign: 'center',
        marginTop: '50px',
        fontSize: '16px'
    },
    dialogActions: {
        justifyContent: 'space-evenly',
        padding: '20px 20px 30px 20px',
    },
    occDiv: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        justifyContent: 'space-between',
    },
});
